import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { GamesContext, IGamesContext } from 'modules/Entertainment/Games/Games/gamesState/gamesContext';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, searchString, selectedDeveloper, selectedCategory, isUnassignedGames } =
		useContext<IGamesContext>(GamesContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: searchString || selectedDeveloper || selectedCategory || isUnassignedGames,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
